import isSection from './isSection';

export default function flattenItems(items) {
    // if no item is section, we just return what was given
    if (!items.some((item) => isSection(item))) return items;

    return items.reduce((previous, item) => {
        if (isSection(item)) {
            return [...previous, ...item.items];
        }

        return [...previous, item];
    }, []);
}
